<template>
  <!--
      作者：fzf
      时间：2025-07-23
      描述：会员-用户列表-会员课程礼包
  -->
  <div>
  <el-dialog title="会员课程礼包" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">

      <el-form size="small" :model="form">


          <el-checkbox-group
            v-model="checkedCities">
            <el-checkbox v-for="(item,index) in cities" :key="index" :label="item">{{item}}</el-checkbox>
          </el-checkbox-group>

          <br/><br/>
           <div class="tips">推送课程，在【我的】-【已购课程】里面观看；若已推送的不会再推送</div>




    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>

    </div>
  </el-dialog>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';


const cityOptions = ['1:易经的启迪', '2:道德经智慧', '3:有易少年读书', '4:八卦原传风水', '5:黄帝内经','6:解码易经的奥秘','7:历史中的五组密码','8:慧眼识人','9:神秘的面相学王钧正','10:心灵之桥','11:八卦的奥秘'];
  export default {
    data() {
      return {
         open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,

        checkedCities: [],
        cities: cityOptions,
      };
    },
    props: ['open_edit_course', 'form'],
    created() {
      this.dialogVisible = this.open_edit_course;
      this.checkedCities = this.form.checkedCities;
      // this.clist = form.clist;
      // this.form.clist=[
      //   {"id":1,'name':'易经的启迪','buy':true},
      //   {"id":2,'name':'道德经智慧','buy':false},
      //   // {"id":3,'name':'有易少年读书'},
      //   {"id":4,'name':'八卦原传风水','buy':false},
      //   {"id":5,'name':'黄帝内经','buy':false},
      //   {"id":6,'name':'解码易经的奥秘','buy':false},
      //   {"id":7,'name':'历史中的五组密码','buy':false},
      //   {"id":8,'name':'慧眼识人','buy':false},
      //   {"id":9,'name':'神秘的面相学王钧正','buy':false},
      //   {"id":10,'name':'心灵之桥','buy':false},
      // ];
    },
    methods: {

      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = self.form;
        params.courses = self.checkedCities;
        // console.log(params);return;
        UserApi.editusercourse(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      buy(item){
        console.log(item)
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        console.log(e)
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/GradeCourse.vue